import { dDom } from '../../../core/js/utils/renderUtils';
import template from 'category-title.j2';
import { generate } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';

/**
 * This component is responsibile for managing the title attribute of the category page
 * @param store
 * @param overrides
 * @returns {*}
 */
export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.js-category-title-component',
        watch: 'category.catalogRequestUrl',
        name: 'categoryTitle',
        template: template,
        renderType: dDom
    };
    return generate(config, store, overrides, getDefaultOptions(store));
}
